"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticTeamType = void 0;
/**
 * The default team types seeded into each Transcend account
 * used for mapping of action items
 */
var StaticTeamType;
(function (StaticTeamType) {
    StaticTeamType["Engineering"] = "ENGINEERING";
    StaticTeamType["DsrManagement"] = "DSR_MANAGEMENT";
    StaticTeamType["ReadOnly"] = "READ_ONLY";
    StaticTeamType["PrivacyCenterManagement"] = "PRIVACY_CENTER_MANAGEMENT";
    StaticTeamType["AccessControlManagement"] = "ACCESS_CONTROL_MANAGEMENT";
    StaticTeamType["Design"] = "DESIGN";
    StaticTeamType["LegalPrivacyOps"] = "LEGAL_PRIVACY_OPS";
    StaticTeamType["ItInfoSec"] = "IT_INFO_SEC";
    StaticTeamType["DatabaseAdminDataEngineering"] = "DATABASE_ADMIN_DATA_ENGINEERING";
    StaticTeamType["CloudInfraArchitecture"] = "CLOUD_INFRA_ARCHITECTURE";
    StaticTeamType["ProjectManagers"] = "PROJECT_MANAGERS";
    StaticTeamType["Marketing"] = "MARKETING";
    StaticTeamType["SystemOwners"] = "SYSTEM_OWNERS";
    StaticTeamType["FrontendDeveloper"] = "FRONTEND_DEVELOPER";
})(StaticTeamType || (exports.StaticTeamType = StaticTeamType = {}));
//# sourceMappingURL=team.js.map